module.exports = __webpack_public_path__ + "static/15-aaf4c3fb06f225b524c5c76dab16dee4.jpg";